import { render, staticRenderFns } from "./realEstateResources.vue?vue&type=template&id=45fbad07&"
import script from "./realEstateResources.vue?vue&type=script&lang=js&"
export * from "./realEstateResources.vue?vue&type=script&lang=js&"
import style0 from "./realEstateResources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports